import { Box, Button, Stack, type SxProps, type Theme } from '@mui/material';
import LeavesFallingGIF from 'src/assets/animation/LeavesFalling.gif';
import {
  Dialog,
  DialogHeader,
  DialogSubTitle,
  DialogTitle,
} from 'src/components/appDialog/index.styles';
import config from 'config';
import { useAppSelector } from 'src/redux';

const PaymentNotSupported = ({
  onClose,
  open,
  sx,
}: {
  open: boolean;
  onClose: () => void;
  sx?: SxProps<Theme>;
}) => {
  const { token } = useAppSelector((state) => state.auth);
  const onContinue = () => {
    onClose();
    window.open(
      `${config.JOBS_BASE_URL}/login?token=${token}&redirectTo=/store`,
    );
  };
  return (
    <Dialog open={open} onClose={onClose} sx={sx}>
      <DialogHeader></DialogHeader>
      <Stack sx={{ alignItems: 'center', gap: '4px' }}>
        <DialogTitle sx={{ textAlign: 'center' }}>
          Payments Not Supported in App
        </DialogTitle>
        <Box
          component={'img'}
          src={LeavesFallingGIF}
          sx={{ width: 108, height: 108 }}
        />
        <DialogSubTitle sx={{ textAlign: 'center' }}>
          Please complete your purchase using website.
        </DialogSubTitle>
      </Stack>
      <Button
        onClick={onContinue}
        variant="contained"
        sx={{ borderRadius: '12px', py: '8px' }}
      >
        Continue
      </Button>
    </Dialog>
  );
};

export default PaymentNotSupported;
